
export class LicenseService {
  private static instance: LicenseService;
  
  private constructor() {}
  
  public static getInstance(): LicenseService {
    if (!LicenseService.instance) {
      LicenseService.instance = new LicenseService();
    }
    return LicenseService.instance;
  }
  
  public async verifyLicense(
    apiUrl: string | undefined,
    systemUrl: string | undefined,
    systemToken: string | undefined,
    systemType?: string | undefined
  ): Promise<boolean> {
    console.log('licenseService.verifyLicense: Called with parameters', {
      hasApiUrl: !!apiUrl,
      apiUrl,
      hasSystemUrl: !!systemUrl,
      hasSystemToken: !!systemToken,
      systemType
    });

    if (!systemUrl || !systemToken || !apiUrl) {
      return false;
    }

    try {
      const endpoint = `${apiUrl}/license/check`;

      const requestBody = {
        systemUrl: systemUrl,
        systemToken: systemToken,
        systemType: systemType,
      };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });


      if (response.ok) {
        const data = await response.json();
        return data.hasPaidLicenseAccess;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }
}

export const licenseService = LicenseService.getInstance();